import { render, staticRenderFns } from "./tiered-message.vue?vue&type=template&id=03cc8fde&"
import script from "./tiered-message.vue?vue&type=script&lang=js&"
export * from "./tiered-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports